import React from 'react';
import styles from './KPIsPill.module.scss';
import Icon from '../Icon/Icon';
import { useSelector } from 'react-redux';

interface ITagProps {
  code: string;
  label?: string;
  onPillClick: (name: any) => void;
  isSelected?: boolean;
  key?: any;
  isIcon?: boolean;
  dotColor?: string;
}

const KPIsPill: React.FC<ITagProps> = ({ code, label, onPillClick, isSelected, isIcon, dotColor }) => {
  const currentTheme = useSelector((state: any) => state.theme.currentTheme);

  return (
    <div
      className={`${styles.pill} ${isSelected ? styles.selected_pill : ''}`}
      onClick={() => onPillClick(code)}
    >
      {dotColor && (
        <span
          style={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: dotColor,
            display: 'inline-block',
          }}
        />
      )}
      {isIcon && isSelected && (
        <span className={styles.pill_icon}>
          <Icon
            name="selected_tick_circle"
            color={currentTheme === 'light' ? '#fff' : '#000'}
            size={16}
          />
        </span>
      )}
      {/* Add MApper and display label usiing code */}
      <span className={`${styles.pill_label}`}>{label}</span>
    </div>
  );
};

export default KPIsPill;
